var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { VStack } from '@chakra-ui/react';
import { Layout } from 'src/core/components';
import { DistributorStats } from 'src/distributor/components';
export var Dashboard = function () {
    return (_jsx(Layout, __assign({ bodyProps: { px: 0 } }, { children: _jsx(VStack, __assign({ pt: 3, spacing: 5, alignItems: "stretch" }, { children: _jsx(DistributorStats, {}, void 0) }), void 0) }), void 0));
};
